module.exports = __webpack_public_path__ + "mx.1fcc3cf0c7e6ca135612.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/4x3/mx.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/4x3/mx.svg
// module chunks = styles